import { FormikHelpers } from "formik";
import { useCreateOteConType } from "./api/createOteConType";
import OteConTypeForm from "./OteConTypeForm";


const CreateOteConType = ({handleCloseModal}: CreateTypeProps)  => {
  const createOteConTypeMutation = useCreateOteConType({data: {}});

  const initialValues: IPostNewOteConType = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewOteConType, { setSubmitting }: FormikHelpers<IPostNewOteConType>): Promise<void> => {
    try {
      await createOteConTypeMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <OteConTypeForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateTypeProps {
  handleCloseModal: () => void;
}

export default CreateOteConType;